<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><customer-sidebar></customer-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Mes Matchs</h2>
                        </div>
                        <!-- <div class="alert alert-warning alert-dismissible fade show rounded-xl"
                            :class="{ 'd-none': currentUser.phone_number }" role="alert">
                            Merci de renseigner votre numéro téléphone <a href="/my/profile"><b>ici</b></a> pour valider
                            votre compte.
                        </div>
                        <div class="alert alert-warning alert-dismissible fade show"
                            :class="{ 'd-none': currentUser.is_verified || !currentUser.phone_number }" role="alert">
                            Merci de vérifier votre numéro téléphone <a href="/otp-verification"><b>ici</b></a> pour
                            valider votre compte.
                        </div> -->
                        <div>
                            <div class="d-flex justify-content-center align-items-center">
                                <!-- <a v-for="tab in tabs" @click="this.getMatches(tab.id)" :class="{ 'bg-warning-light': activeTab === tab.id }" 
                                    href="javascript:void(0)" class="badge badge-pill text-dark bg-light text-xs mr-1 py-3 px-4">{{ tab.label }}</a> -->
                                <a v-for="tab in tabs" @click="getMatches(tab.id)" :class="{ 'bg-warning-light': activeTab === tab.id, 'ml-1': tab.id !== tabs[0].id }" 
                                    href="javascript:void(0)" class="position-relative badge badge-pill text-dark bg-light text-xs py-3 px-3">
                                    <span class="px-1">{{ tab.label }}</span>
                                    <span v-if="tab.count > 0"
                                        class="badge badge-dark text-white position-absolute mr-2 mt-2 p-1 rounded-xl"
                                        style="min-width: 20px; top:0; right:0; transform: translate(50%, -50%);">
                                        {{ tab.count }}
                                    </span>
                                </a>
                            </div>

                            <div class="tab-content py-3 mb-5">
                                <div class="tab-pane fade show active pt-3">
                                    <div v-if="matches.length === 0" class="text-center">
                                        <span class="text-sm d-block mb-4 mt-2">Aucun match.</span>
                                    </div>
                                    <div v-else>
                                        <div class="table-responsive text-xs p-lg-2 p-0 mt-2">
                                            <table class="table table-hover table-center mb-0">
                                                <thead class="bg-light">
                                                    <tr>
                                                        <th>Match</th>
                                                        <th>Terrain / Le</th>
                                                        <th>Statut</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="match in paginatedData" :key="match.id" class="position-relative">
                                                        <td style="min-width: 160px;">
                                                            <div class="">
                                                                <div class="d-flex justify-content-between align-items-center mb-1">
                                                                    <div class="d-flex justify-content-start align-items-center">
                                                                        <img :src="match.team_a?.logo || defaultLogoPath" class="mr-1 p-1 bg-white rounded-lg" style="width: 42px;height: 42px;"/>
                                                                        <span>{{ match.team_a?.name || 'N/A' }}</span>
                                                                    </div>
                                                                    <b class="text-center" style="width: 20px">{{ (match.status != 'completed') ? '-' : match.score_a }}</b>
                                                                </div>
                                                                <div class="d-flex justify-content-between align-items-center">
                                                                    <div class="d-flex justify-content-start align-items-center">
                                                                        <img :src="match.team_b?.logo || defaultLogoPath" class="mr-1 p-1 bg-white rounded-lg" style="width: 42px;height: 42px;"/>
                                                                        <span>{{ match.team_b?.name || 'N/A' }}</span>
                                                                    </div>
                                                                    <b class="text-center" style="width: 20px">{{ (match.status != 'completed') ? '-' : match.score_b }}</b>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td style="min-width: 100px">
                                                            <div v-if="match.booking">
                                                                <div class="d-flex justify-content-start align-items-center mb-0">
                                                                    <img :src="match.booking?.slot.facility.establishment.logo_url || defaultLogoPath" class="mr-2 p-2 bg-white rounded-lg" style="width: 46px;height: 46px;"/>
                                                                    <div class="d-flex flex-column justify-content-center">
                                                                        <span>Terrain {{ match.booking?.slot.facility.name }}</span>
                                                                        <span class="text-muted">{{ match.booking?.slot.facility.establishment.business_name }}</span>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    {{ formatDateTime(match.booking?.start_time).date }}
                                                                    <span class="d-block text-muted text-xs">
                                                                        {{ formatDateTime(match.booking?.start_time).time }} - {{ formatDateTime(match.booking?.end_time).time }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div v-else-if="!match.booking && match.suggestions?.length">Des propositions</div>
                                                            <div v-else>N.A.</div>
                                                        </td>
                                                        <td>
                                                            <span :class="statuses[match.status]['class']" class="badge badge-pill text-xs py-1 px-2 my-1 mr-1">
                                                                {{ statuses[match.status]['label'] }}
                                                                <template v-if="match.status === 'challenged' && isTeamCaptainOrOwner(match.team_a)">envoyé</template>
                                                                <template v-if="match.status === 'challenged' && isTeamCaptainOrOwner(match.team_b)">reçu</template>
                                                            </span>
                                                            <span v-if="match.status === 'challenged'" :class="challengeStatuses[match.challenge_status]['class']" class="badge badge-pill text-xs py-1 px-2">
                                                                {{ challengeStatuses[match.challenge_status]['label'] }}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div v-if="match.status === 'challenged'" class="text-center">
                                                                <a v-if="['pending','countered'].includes(match.challenge_status)" :href="'/my/matches/' + match.id" class="btn btn-sm btn-primary mb-2">Détails</a>
                                                            </div>
                                                            <a v-if="match.status !== 'cancelled'" :href="'/my/matches/' + match.id" class="stretched-link"></a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- PAGINATION -->
                                        <nav class="mt-3">
                                            <ul class="pagination justify-content-center">
                                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                    <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                                                        <span class="material-symbols-outlined text-sm">arrow_back</span>
                                                    </button>
                                                </li>
                                                <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                                                    <button class="page-link" @click="goToPage(page)" :class="{ 'text-white': currentPage === page, 'text-muted': currentPage !== page }">
                                                        {{ page }}
                                                    </button>
                                                </li>
                                                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                                    <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                                                        <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>

</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import defaultLogoPath from '@/assets/img/default-team-logo.png'
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        vSelect
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        totalPages() {
            return Math.ceil(this.matches.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.matches.slice(start, start + this.perPage);
        },
    },
    data() {
        return {
            defaultLogoPath: defaultLogoPath,
            activeTab: 'scheduled',
            tabs: [
                { id: 'challenged', label: 'Défis', statuses: ['challenged'] },
                { id: 'scheduled', label: 'Prochains', statuses: ['scheduled'] },
                { id: 'completed', label: 'Terminés', statuses: ['completed', 'scheduled'] },
                { id: 'failed', label: 'Échoués', statuses: ['cancelled', 'unfinished'] }
            ],
            statuses: {
                'challenged': {'label': 'défi', 'class': 'bg-primary'},
                'scheduled': {'label': 'à venir', 'class': 'bg-primary-light'},
                'completed': {'label': 'terminé', 'class': 'bg-success-light'},
                'cancelled': {'label': 'annulé', 'class': 'bg-danger text-white'},
                'unfinished': {'label': 'inachevé', 'class': 'bg-danger-light'},
            },
            challengeStatuses: {
                'pending': {'label': 'en attente', 'class': 'bg-warning-light'},
                'countered': {'label': 'contre-proposé', 'class': 'bg-info-light'},
                'accepted': {'label': 'accepté', 'class': 'bg-success-light'},
                'declined': {'label': 'rejeté', 'class': 'bg-danger-light'},
                'cancelled': {'label': 'annulé', 'class': 'bg-danger-light'},
            },
            player: {},
            matches: [],
            search: {
                criteria: {
                    teams: {}
                },
                teams: []
            },
            teamDetails: {},
            currentPage: 1,     // selected page
            perPage: 5,         // items per page
        }
    },
    mounted() {
        this.getMyPlayerProfile()
        this.getMatches()
        this.user = this.currentUser
    },
    methods: {
        getMyPlayerProfile() {
            api.get('/private/players/me')
                .then(response => {
                    const result = response.data
                    this.player = result
                })
        },
        getMatches(status = null) {
            status = status ? status: this.activeTab
            this.activeTab = status;
            this.currentPage = 1;
            api.get("/private/matches")
                .then(response => {
                    const result = response.data;
                    this.countByTabs(result)
                    const tab = this.tabs.filter(tab => tab.id == status)[0]
                    if (status == 'challenged') {
                        this.matches = result.filter(match => tab.statuses.includes(match.status) && this.canViewMatch(match) && ['pending','countered','accepted'].includes(match.challenge_status))
                    } else if (status == 'scheduled') {
                        this.matches = result.filter(match => {
                            return tab.statuses.includes(match.status) && this.canViewMatch(match) && match.booking?.start_time > moment().format("YYYY-MM-DDTHH:mm:ss.000000")
                        })
                    } else if (status == 'completed') {
                        this.matches = result.filter(match => tab.statuses.includes(match.status) && this.canViewMatch(match) && match.booking?.start_time <= moment().format("YYYY-MM-DDTHH:mm:ss.000000"))
                        this.matches = this.matches.map(match => {
                            match.status = 'completed'
                            return {
                                ...match
                            }
                        })
                    } else if (status == 'failed') {
                        this.matches = result.filter(match => tab.statuses.includes(match.status) || ['declined'].includes(match.challenge_status))
                    }
                });
        },
        countByTabs(all_matches) {
            this.tabs.forEach(tab => {
                let matches = all_matches
                if (tab.id == 'challenged') {
                    matches = matches.filter(match => tab.statuses.includes(match.status) && this.canViewMatch(match) && ['pending','countered','accepted'].includes(match.challenge_status))
                } else if (tab.id == 'scheduled') {
                    matches = matches.filter(match => {
                        return tab.statuses.includes(match.status) && this.canViewMatch(match) && match.booking?.start_time > moment().format("YYYY-MM-DDTHH:mm:ss.000000")
                    })
                } else if (tab.id == 'completed') {
                    matches = matches.filter(match => tab.statuses.includes(match.status) && this.canViewMatch(match) && match.booking?.start_time <= moment().format("YYYY-MM-DDTHH:mm:ss.000000"))
                } else if (tab.id == 'failed') {
                    matches = matches.filter(match => tab.statuses.includes(match.status) || ['declined'].includes(match.challenge_status))
                }
                tab.count = matches.length;
            });
        },
        notStartedYet(match) {
            return this.formatDateTime(match.booking?.start_time).datetime > moment().format('YYYY-MM-DD HH:mm')
        },
        respondToChallenge(match_id, status) {
            api.post(`/private/matches/${match_id}/challenge`, {status: status})
                .then(response => {
                        this.getMatches()
                    })
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return { date: '-', time: '-', datetime: '' };
            const date = moment(datetimeString);
            const formattedDate = date.format('DD MMM YYYY').replace(/\b\p{L}/u, letter => letter.toUpperCase()).replace(/\./g, '');
            const hours = date.format('HH');
            const minutes = date.format('mm');
            let date_obj = {
                date: formattedDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
        goToPage(page, list='default') {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        isAcceptedTeamMember(team) {
            if (!team || !this.player?.id || !Array.isArray(team.memberships)) return false;
            return team.memberships.some(membership => membership.player_id === this.player.id && membership.status === 'accepted');
        },
        canViewMatch(match) {
            const isTeamCaptainOrOwner = [match.team_a.captain_id, match.team_a.owner_id].includes(this.player.id) || [match.team_b.captain_id, match.team_b.owner_id].includes(this.player.id)
            const isTeamMember = this.isAcceptedTeamMember(match.team_a) || this.isAcceptedTeamMember(match.team_b)
            const lineup = Array.isArray(match.lineups) ? match.lineups.filter(l => l.player_id === this.player.id) : []
            return isTeamCaptainOrOwner || isTeamMember || lineup.length > 0
        },
        isTeamCaptainOrOwner(team) {
            if (!team || !this.player?.id) return false;
            return team?.owner_id === this.player.id || team?.captain_id === this.player.id;
        }
    },
};
</script>
